import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputNumberLocaleDirective } from './input-number-locale.directive';
import { SelectModule } from 'primeng/select';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { TreeSelectModule } from 'primeng/treeselect';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PasswordModule } from 'primeng/password';
import { CardModule } from 'primeng/card';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { Skeleton } from 'primeng/skeleton';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { TextareaModule } from 'primeng/textarea';
import { TimelineModule } from 'primeng/timeline';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { Avatar } from 'primeng/avatar';
import { DragDropModule } from 'primeng/dragdrop';
import { DrawerModule } from 'primeng/drawer';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import { IftaLabelModule } from 'primeng/iftalabel';
import { TabsModule } from 'primeng/tabs';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { SplitButtonModule } from 'primeng/splitbutton';
import { PaginatorModule } from 'primeng/paginator';
import { SpeedDialModule } from 'primeng/speeddial';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';

import { ServerSearchDirective } from '@card-software/nexus-utilities';

const primeNG = [
  ServerSearchDirective,
  AccordionModule,
  AutoComplete,
  AutoCompleteModule,
  Avatar,
  BreadcrumbModule,
  ButtonModule,
  CardModule,
  CalendarModule,
  CheckboxModule,
  ConfirmDialogModule,
  DatePickerModule,
  DragDropModule,
  DialogModule,
  DrawerModule,
  DropdownModule,
  FloatLabelModule,
  IconFieldModule,
  IftaLabelModule,
  InputGroupModule,
  InputGroupAddonModule,
  InputIconModule,
  InputNumberModule,
  InputTextModule,
  ListboxModule,
  MenuModule,
  MessageModule,
  MultiSelectModule,
  PanelMenuModule,
  PanelModule,
  PasswordModule,
  PaginatorModule,
  ProgressBarModule,
  ScrollPanelModule,
  SelectButtonModule,
  SelectModule,
  Skeleton,
  SpeedDialModule,
  TableModule,
  TreeTableModule,
  TreeSelectModule,
  TabsModule,
  TagModule,
  TextareaModule,
  TimelineModule,
  ToastModule,
  ToggleButtonModule,
  ToggleSwitchModule,
  TooltipModule,
  SplitButtonModule,
];
@NgModule({
  declarations: [],
  imports: [primeNG, CommonModule, InputNumberLocaleDirective],
  exports: [primeNG, InputNumberLocaleDirective],
})
export class PrimengModule {}
